export default __webpack_public_path__ + "static/media/CASH-OUT-DONE.678a385b.png";